import {
  errorForm,
  logger,
  ITaskData,
  task,
} from "@origin-digital/reporting-client";

import { pageRoutes, trackingIds } from "src/consts";
import { ITrackingContext } from "src/context/TrackingContext";
import { ProfileFieldMapTypes } from "../crm/profileFieldMapContextHelpers";

export const getTrackingId = (type?: ProfileFieldMapTypes) => {
  const path = window.location.pathname;
  const typeSuffix = type ? `-${type}` : "";
  if (path.includes(pageRoutes.updateAddress.form)) {
    return `${trackingIds.updateAddress}${typeSuffix}`;
  } else if (path.includes(pageRoutes.updateDob.form)) {
    return `${trackingIds.updateDob}${typeSuffix}`;
  } else if (path.includes(pageRoutes.updateEmail.form)) {
    return `${trackingIds.updateEmail}${typeSuffix}`;
  } else if (path.includes(pageRoutes.updateLandline.form)) {
    return `${trackingIds.updateLandline}${typeSuffix}`;
  } else if (path.includes(pageRoutes.updateMobile.form)) {
    return `${trackingIds.updateMobile}${typeSuffix}`;
  }
  return `${trackingIds.base}${typeSuffix}`;
};

export const errorTracking = (
  error: Error,
  type?: ProfileFieldMapTypes
): void => {
  logger.warn(`errorTracking()${type ? ` - ${type}` : ""}`, error);

  const errorFormData = {
    errorCode: error.name,
    errorMessage: error.message,
    formName: getTrackingId(type),
  };

  errorForm(errorFormData);
};

export const formTracking = (
  action: ITaskData["action"],
  { context, setTrackingContext }: ITrackingContext,
  type?: ProfileFieldMapTypes
) => {
  if (context[action]) return;

  const formName = getTrackingId(type);
  task.base(formName, { action, formName });
  setTrackingContext({ [action]: true });
};
